export default __webpack_public_path__ + "static/media/background.9c3b9fb6.jpg";